import { bootPage } from "./bootstrap";

import { getPageModule } from "./modules";
import { supportNonGETMethodsOnLinks } from "./utils";

require("./css/app.scss");

// these images are used throughout the application's blade templates, required here
// to ensure they're passed through webpack for optimization and listed in the cache
// manifest for each release
require("./images/footer--logo-lockup.svg");
require("./images/logo-lockup.svg");
require("./images/about--family.jpg");
require("./images/about--andrew-johnson.jpg");
require("./images/events.jpg");
require("./images/home--why-choose.jpg");
require("./images/home--why-choose@2x.jpg");
require("./images/home--advantage@2x.jpg");
require("./images/home--how--find-a-tutor.svg");
require("./images/home--how--meet.svg");
require("./images/home--how--schedule.svg");
require("./images/home--offer--online-in-person.svg");
require("./images/home--offer--convenient.svg");
require("./images/home--offer--personalized.svg");
require("./images/home--offer--results.svg");
require("./images/home--hero-bg@2x.jpg");
require("./images/photo-placeholder.svg");
require("./images/icon--twitter.svg");
require("./images/icon--linkedin.svg");
require("./images/icon--youtube.svg");
require("./images/icon--facebook.svg");

require("./images/icon--schedule--white.svg");
require("./images/icon--availability--white.svg");
require("./images/icon--settings--white.svg");
require("./images/icon--profile--white.svg");

require("./images/icon--dashboard.svg");
require("./images/icon--schedule.svg");
require("./images/icon--availability.svg");
require("./images/icon--settings.svg");
require("./images/icon--profile.svg");
require("./images/icon--logout.svg");

require("./images/phonics.png");
require("./images/basics.png");
require("./images/mathfacts.png");
require("./images/writing.jpeg");
require("./images/authentic-writing.png");

require("./images/stripe-badge-white.png");

document.addEventListener("DOMContentLoaded", () => {
  supportNonGETMethodsOnLinks();
  bootPage(getPageModule("body"));

  // TODO : make like frontend
    var header = document.getElementById("header-main");
    var pageContainer = document.getElementById("main-content-container");

    //init handling for internal page containers
    if (pageContainer != null) {
        pageContainer.style.paddingTop = header!.offsetHeight + "px";
    }

    // each time user scrolls page, check if they have scrolled the distance of the alertBox
    // if passed alertbox, move the navbar back to the stop of the page with margin-top
    window.addEventListener("scroll", function() {
        console.log('scroll hit2');
        // update pagecontrainer margin top
        if (pageContainer != null) {
            var navbarHeightUpdated = header!.offsetHeight;
            pageContainer.style.paddingTop = navbarHeightUpdated + "px";
        }
        
    });

});
